/**
 * i18n bootstrap.
 *
 * Detection order:
 *   1. ?lng=xx query string (lets us deep-link a translation for QA)
 *   2. seogeeks:lang in localStorage (sticky user choice)
 *   3. browser navigator.language
 *
 * Supported languages must match Django's LANGUAGES so the marketing
 * site and the SaaS share the same vocabulary. New languages: drop a
 * JSON file in src/i18n/locales/<code>.json and register it below.
 */

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ru from "./locales/ru.json";
import uk from "./locales/uk.json";

export const SUPPORTED_LANGUAGES = [
  { code: "uk", label: "Українська" },
  { code: "ru", label: "Русский" },
  { code: "en", label: "English" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      uk: { translation: uk },
      ru: { translation: ru },
    },
    fallbackLng: "uk",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "seogeeks:lang",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
